import { NovaPerguntaPage } from "@/features/questions";

export default function Page() {
	return <NovaPerguntaPage />;
}
